// @ts-strict-ignore
import { addExperimentGroupToTargeting } from '@platforms/shared';
import {
	BaseServiceSetup,
	context,
	defineExperiment,
	getExperiment,
	Experiment,
	utils,
} from '@wikia/ad-engine';

type RunningExperimentType = Experiment | null | undefined;

const logGroup = 'UcpMobileFloatingIcvWithDrawerExperiment';
const floatingIcvBottomDrawerClassName = 'floating-icv-bottom-with-drawer';
const floatingIcvTopDrawerClassName = 'floating-icv-top-with-drawer';

export class UcpMobileFloatingIcvWithDrawerExperiment extends BaseServiceSetup {
	private pathfinderExperimentVariantNames = {
		control: 'floating-icv-control',
		control2: 'floating-icv-control2',
		variant1: 'floating-icv-variant1',
		variant2: 'floating-icv-variant2',
		variant3: 'floating-icv-variant3',
	};

	private pathfinderExperimentVariants = [
		defineExperiment({
			name: this.pathfinderExperimentVariantNames.control,
			buckets: ['70', '71', '72', '73', '74'],
		}),
		defineExperiment({
			name: this.pathfinderExperimentVariantNames.control2,
			buckets: ['80', '81', '82', '83', '84'],
		}),
		defineExperiment({
			name: this.pathfinderExperimentVariantNames.variant1,
			buckets: ['75', '76', '77', '78', '79'],
		}),
		defineExperiment({
			name: this.pathfinderExperimentVariantNames.variant2,
			buckets: ['85', '86', '87', '88', '89'],
		}),
		defineExperiment({
			name: this.pathfinderExperimentVariantNames.variant3,
			buckets: ['90', '91', '92', '93', '94'],
		}),
	];

	private pathfinderActiveExperimentVariant: RunningExperimentType = getExperiment(
		this.pathfinderExperimentVariants,
	);

	call(): void {
		this.configure();
	}

	private isExperimentEnabled(): boolean {
		return this.instantConfig
			.get('icExperiments', [])
			.includes('mobileFloatingIcvWithDrawerExperiment');
	}

	private configure(): void {
		if (this.isExperimentEnabled() && this.pathfinderActiveExperimentVariant?.name) {
			switch (this.pathfinderActiveExperimentVariant.name) {
				case this.pathfinderExperimentVariantNames.variant1:
					utils.logger(logGroup, 'Variant 1');
					context.set('experiments.floatingIcvWithDrawerExperiment.enabled', true);
					context.set('experiments.floatingIcvWithDrawerExperiment.variant', 1);
					addExperimentGroupToTargeting(this.pathfinderExperimentVariantNames.variant1);
					document.body.classList.add(floatingIcvBottomDrawerClassName);
					break;
				case this.pathfinderExperimentVariantNames.variant2:
					utils.logger(logGroup, 'Variant 2');
					context.set('experiments.floatingIcvWithDrawerExperiment.enabled', true);
					context.set('experiments.floatingIcvWithDrawerExperiment.variant', 2);
					addExperimentGroupToTargeting(this.pathfinderExperimentVariantNames.variant2);
					document.body.classList.add(floatingIcvTopDrawerClassName);
					break;
				case this.pathfinderExperimentVariantNames.variant3:
					utils.logger(logGroup, 'Variant 3');
					context.set('experiments.floatingIcvWithDrawerExperiment.enabled', true);
					context.set('experiments.floatingIcvWithDrawerExperiment.variant', 3);
					addExperimentGroupToTargeting(this.pathfinderExperimentVariantNames.variant3);
					document.body.classList.add(floatingIcvTopDrawerClassName);
					break;
				case this.pathfinderExperimentVariantNames.control:
					utils.logger(logGroup, 'Control group');
					context.set('experiments.floatingIcvWithDrawerExperiment.enabled', false);
					context.set('experiments.floatingIcvWithDrawerExperiment.variant', 4);
					addExperimentGroupToTargeting(this.pathfinderExperimentVariantNames.control);
					break;
				case this.pathfinderExperimentVariantNames.control2:
					utils.logger(logGroup, 'Control group 2');
					context.set('experiments.floatingIcvWithDrawerExperiment.enabled', false);
					context.set('experiments.floatingIcvWithDrawerExperiment.variant', 5);
					addExperimentGroupToTargeting(this.pathfinderExperimentVariantNames.control2);
					break;
			}
		} else {
			utils.logger(logGroup, 'Experiment disabled');
			context.set('experiments.floatingIcvWithDrawerExperiment.enabled', false);
			return;
		}
	}
}
